import { formatDate } from "../formating";
import { normalizeString } from "../functions";

const profileSchema = {
  firstName: (firstName) =>
    normalizeString({ data: firstName, actions: ["spacing"] }),
  lastName: (lastName) =>
    normalizeString({ data: lastName, actions: ["spacing"] }),
  email: (email) => normalizeString({ data: email, actions: ["spacing"] }),
  password: (password) => password,
  phone: (phone) => String(phone),
  city: (city) => normalizeString({ data: city, actions: ["spacing"] }),
  state: (state) => normalizeString({ data: state, actions: ["spacing"] }),
  zip: (zip) => String(zip).replace("-", ""),
  country: (country) => "US",
  addressLine1: (addressLine1) =>
    normalizeString({ data: addressLine1, actions: ["spacing"] }),
  addressLine2: (addressLine2) =>
    normalizeString({ data: addressLine2, actions: ["spacing"] }),
  insuranceCompanyId: (insuranceCompanyId) => insuranceCompanyId,
  birthdayYear: (birthdayYear) => birthdayYear,
  socialSecurityNumber: (socialSecurityNumber) => {
    const formatted = socialSecurityNumber.replace(/-/g, "");
    return formatted;
  },
  dateOfBirth: (dob) =>
    formatDate({
      actions: ["mysql"],
      data: dob,
    }),
  taxFilingStatus: (taxFilingStatus) => taxFilingStatus,
  taxRate: (taxRate) => taxRate,
  taxYearAvailability: (taxYearAvailability) => taxYearAvailability,
  isDeductibleOk: (isDeductibleOk) => isDeductibleOk === "Yes",
  isHighDeductible: (isDeductibleOk) => isDeductibleOk === "Yes",
  isMaxOutOfPocketOk: (isMaxOutOfPocketOk) => isMaxOutOfPocketOk === "Yes",
  isDependent: (isDependent) => isDependent === "Yes",
  isMedicare: (isMedicare) => isMedicare === "Yes",
  isOtherCoverage: (isOtherCoverage) => isOtherCoverage === "Yes",
  isExistingHsa: (isExistingHsa) => isExistingHsa === "Yes",
  isHsaRecentActivity: (isHsaRecentActivity) => isHsaRecentActivity === "Yes",
  existingBalance: (existingBalance) => existingBalance,
  mode: (mode) => mode,
  checkoutSessionId: (checkoutSessionId) => checkoutSessionId,
  isAutoRenew: (isAutoRenew) => isAutoRenew,
  createSubscription: (createSubscription) => createSubscription,

  companyName: (companyName) => companyName,
  name: (name) => name,
};

export default profileSchema;
